import React, { FC } from 'react'
import styles from './Skeleton.module.scss'
import classNames from 'classnames'

type SkeletonProps = {
  width?: string
  height?: string
  shape?: 'rect' | 'circle'
  className?: string
}

const Skeleton: FC<SkeletonProps> = ({
  width = '100%',
  height = '20px',
  shape = 'rect',
  className = '',
}) => {
  return (
    <div
      className={classNames(styles.skeleton, {
        [styles.skeletonCircle]: shape === 'circle',
        [className]: className !== '',
      })}
      style={{
        width,
        height,
      }}
    />
  )
}

export default Skeleton
